// extracted by mini-css-extract-plugin
module.exports = {"heading":"_2pUD-QN49z9MqmwnpUOdxp","frameResizer":"_3muYDqgRDQu_0vHZsFP3iN","frame":"_2dmpKRpjYW7Lq_S7nYxGD7"};